module.exports = __webpack_public_path__ + "img/logo-jet.6b2a3291.svg";